import { render } from "./eng_flag.vue?vue&type=template&id=adc0dab6"
const script = {}

import "./eng_flag.vue?vue&type=style&index=0&id=adc0dab6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__